import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalizationService } from 'src/app/general/services/localization.service';
import { SidebarService } from '../../services/sidebar.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NavigationService } from '../../services/navigation.service';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceService } from 'src/app/general/services/device.service';

@Component({
  selector: 'app-sidebar-content',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule
  ],
  templateUrl: './sidebar-content.component.html',
  styleUrls: ['./sidebar-content.component.css']
})
export class SidebarContentComponent {

  languageToSwitchTo: string;

  constructor(
    public deviceService: DeviceService,
      private navigationService: NavigationService,
      private sidebarService: SidebarService,
      private localizationService: LocalizationService) {
    if (this.localizationService.isSpanish()) {
      this.languageToSwitchTo = 'English';
    } else {
      this.languageToSwitchTo = 'Español';
    }
  }

  public toggleLanguage(): void {
    if (this.localizationService.isSpanish()) {
      this.localizationService.setEnglish();
      this.languageToSwitchTo = 'Español';
    } else {
      this.localizationService.setSpanish();
      this.languageToSwitchTo = 'English';
    }
    this.toggleSidebar();
  }

  public toggleSidebar(): void {
    this.sidebarService.toggleSidebar();
  }

  public goToPricingPage(): void {
    this.toggleSidebar();
    this.navigationService.goToPricingPage();
  }

  public goToRequirementsPage(): void {
    this.toggleSidebar();
    this.navigationService.goToRequirementsPage();
  }

  public goToFoodTruckPage(): void {
    this.toggleSidebar();
    this.navigationService.goToFoodTruckPage();
  }

  public goToRestaurantPage(): void {
    this.toggleSidebar();
    this.navigationService.goToRestaurantPage();
  }

  public goToSupportPage(): void {
    this.toggleSidebar();
    this.navigationService.goToSupportPage();
  }

  public goToBusinessWeb(): void {
    this.toggleSidebar();
    this.navigationService.goToBusinessWeb();
  }
}
